import { Input, InputProps } from 'antd';

interface Props extends Omit<InputProps, 'onChange'> {
  onChange?: (val: string) => void;
  value?: string;
}

export const TrimInput = ({ value, onChange, ...props }: Props) => {
  return (
    <Input
      {...props}
      value={value}
      onChange={(e) => {
        if (typeof onChange === 'function') {
          onChange(e.target.value.trim());
        }
      }}
    />
  );
};
